import { I18nUtils } from '@medable/i18n-core';
import { normalizeLocale } from 'libs.i18n-core';
import { getApiLocale } from './pseudo_locale.helpers';
export const getLocaleRecords = async (locale) => {
    const i18nLocale = I18nUtils.cortexToI18nFormat(locale);
    const json = await import(`../../../../locales/lumos/${i18nLocale}.json`);
    return json.default;
};
export const getLanguageHeaders = (locale) => {
    if (!locale) {
        return {};
    }
    const supportedLocale = normalizeLocale(getApiLocale(locale) || locale, { fallbackToEnUs: true });
    return {
        headers: {
            'Accept-Language': supportedLocale,
        },
    };
};
